<template>
  <div class="order-pay-page">
    <van-nav-bar title="订单支付" left-arrow @click-left="goBack" />

    <!-- 支付信息 -->
    <div class="pay-card">
      <div class="pay-amount">
        <div class="amount-label">{{ payType === 'deposit' ? '支付订金' : '支付全款' }}</div>
        <div class="amount-value">¥{{ formatPrice(payAmount) }}</div>
      </div>
      <div class="pay-order">
        <span>订单号：{{ orderNo }}</span>
        <span class="copy-btn" @click="copyOrderNo">复制</span>
      </div>
    </div>

    <!-- 支付方式 -->
    <div class="section-card">
      <div class="section-title">选择支付方式</div>
      <van-radio-group v-model="payMethod">
        <div class="pay-method-item">
          <div class="method-icon">💳</div>
          <div class="method-info">
            <div class="method-name">微信支付</div>
            <div class="method-desc">推荐使用</div>
          </div>
          <van-radio name="wechat" checked-color="#ee0a24" />
        </div>
        <div class="pay-method-item">
          <div class="method-icon">💰</div>
          <div class="method-info">
            <div class="method-name">支付宝</div>
            <div class="method-desc">快捷支付</div>
          </div>
          <van-radio name="alipay" checked-color="#ee0a24" />
        </div>
      </van-radio-group>
    </div>

    <!-- 支付说明 -->
    <div class="section-card">
      <div class="section-title">支付说明</div>
      <div class="pay-notice">
        <p>1. 订单有效期为24小时，请在有效期内完成支付</p>
        <p>2. 支付完成后，系统会自动确认收款</p>
        <p v-if="payType === 'deposit'">3. 订金支付后需等待公证完成，再支付尾款</p>
        <p v-else>3. 全款支付后卖家将在约定时间内交付资料</p>
      </div>
    </div>

    <!-- 底部支付按钮 -->
    <div class="submit-bar">
      <div class="submit-info">
        <span class="submit-label">实付：</span>
        <span class="submit-price">¥{{ formatPrice(payAmount) }}</span>
      </div>
      <van-button
        type="danger"
        round
        class="submit-btn"
        :loading="paying"
        @click="doPay"
      >
        立即支付
      </van-button>
    </div>

    <!-- 支付结果弹窗 -->
    <van-popup v-model="showResult" round closeable position="center" class="result-popup">
      <div class="result-content">
        <div class="result-icon" v-if="paySuccess">✅</div>
        <div class="result-icon" v-else>❌</div>
        <div class="result-title">{{ paySuccess ? '支付成功' : '支付失败' }}</div>
        <div class="result-desc" v-if="paySuccess">
          {{ payType === 'deposit' ? '订金已支付，等待公证' : '全款已支付，等待交付资料' }}
        </div>
        <div class="result-desc" v-else>{{ failReason }}</div>
        <van-button v-if="paySuccess" type="danger" round block @click="goOrders">
          查看订单
        </van-button>
        <van-button v-else type="danger" round block @click="retryPay">
          重新支付
        </van-button>
        <van-button v-if="!paySuccess" plain round block style="margin-top: 12px;" @click="goOrders">
          查看订单
        </van-button>
      </div>
    </van-popup>

    <!-- 二维码弹窗 -->
    <van-popup v-model="showQrCode" round closeable position="center" class="qr-popup">
      <div class="qr-content">
        <div class="qr-title">请使用微信或支付宝扫码支付</div>
        <canvas id="qrCodeCanvas" class="qr-canvas"></canvas>
        <div class="qr-desc">支付金额：<span class="qr-price">¥{{ formatPrice(payAmount) }}</span></div>
        <van-button plain round block style="margin-top: 16px;" @click="goOrders">
          支付完成
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'OrderPayPage',
  data() {
    return {
      orderNo: '',
      payAmount: 0,
      payType: 'full', // deposit: 订金, full: 全款
      payMethod: 'wechat',
      paying: false,
      showResult: false,
      paySuccess: false,
      failReason: '',
      showQrCode: false,
      qrCodeUrl: ''
    }
  },
  created() {
    this.orderNo = this.$route.query.order_no
    this.payAmount = parseFloat(this.$route.query.amount) || 0
    this.payType = this.$route.query.type || 'full'

    if (!this.orderNo || !this.payAmount) {
      this.$common.mAlert(this, '订单信息错误')
      this.$router.replace('/payment')
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    goOrders() {
      this.showResult = false
      this.$router.push('/my-orders')
    },
    retryPay() {
      this.showResult = false
      this.paying = false
    },
    // 复制订单号
    copyOrderNo() {
      const input = document.createElement('input')
      input.value = this.orderNo
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$common.mAlert(this, '已复制')
    },
    // 执行支付
    async doPay() {
      this.paying = true

      try {
        const formData = new FormData()
        formData.append('order_no', this.orderNo)
        formData.append('amount', this.payAmount)
        formData.append('type', this.payType)

        const res = await this.$common.cusHttp(
          this,
          '/api/saas_order.php?action=pay',
          formData,
          'post'
        )
        
        const data = JSON.parse(res.data)
        if (data.status) {
          const qrCodeUrl = data.data.qrCodeUrl
          
          // 判断是否在微信浏览器内
          const isWechat = /MicroMessenger/i.test(navigator.userAgent)
          
          if (isWechat) {
            // 微信内直接跳转
            window.location.href = qrCodeUrl
          } else {
            // 非微信内，显示二维码弹窗
            this.qrCodeUrl = qrCodeUrl
            this.showQrCode = true
            this.$nextTick(() => {
              this.generateQrCode()
            })
          }
        } else {
          this.paySuccess = false
          this.failReason = data.desc || '支付失败，请重试'
          this.showResult = true
        }
      } catch (err) {
        console.error('支付请求失败:', err)
        this.paySuccess = false
        this.failReason = '网络错误，请重试'
        this.showResult = true
      } finally {
        this.paying = false
      }
    },
    // 生成二维码
    generateQrCode() {
      const canvas = document.getElementById('qrCodeCanvas')
      if (canvas) {
        QRCode.toCanvas(canvas, this.qrCodeUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }, function (error) {
          if (error) console.error(error)
        })
      }
    },
    // 格式化价格
    formatPrice(price) {
      if (!price || price <= 0) return '0'
      return Math.round(price).toLocaleString()
    }
  }
}
</script>

<style scoped>
.order-pay-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 80px;
}

.pay-card {
  background: linear-gradient(135deg, #ee0a24, #ff6b6b);
  color: #fff;
  padding: 32px 24px;
  text-align: center;
}

.amount-label {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.amount-value {
  font-size: 40px;
  font-weight: bold;
}

.pay-order {
  margin-top: 16px;
  font-size: 13px;
  opacity: 0.9;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.copy-btn {
  background: rgba(255,255,255,0.2);
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.section-card {
  background: #fff;
  margin: 12px;
  padding: 16px;
  border-radius: 8px;
}

.section-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

/* 支付方式 */
.pay-method-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
}

.pay-method-item:last-child {
  border-bottom: none;
}

.method-icon {
  font-size: 28px;
  margin-right: 12px;
}

.method-info {
  flex: 1;
}

.method-name {
  font-size: 15px;
  color: #333;
  margin-bottom: 4px;
}

.method-desc {
  font-size: 12px;
  color: #999;
}

/* 支付说明 */
.pay-notice {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}

.pay-notice p {
  margin: 0;
}

/* 底部提交 */
.submit-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.05);
}

.submit-info {
  flex: 1;
}

.submit-label {
  font-size: 14px;
  color: #666;
}

.submit-price {
  font-size: 20px;
  font-weight: bold;
  color: #ee0a24;
}

.submit-btn {
  width: 140px;
  height: 44px;
  font-size: 15px;
  background: linear-gradient(135deg, #ff6b6b, #ee0a24);
  border: none;
}

/* 结果弹窗 */
.result-popup {
  width: 80%;
  max-width: 320px;
  padding: 24px;
}

.result-content {
  text-align: center;
}

.result-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.result-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.result-desc {
  font-size: 13px;
  color: #999;
  margin-bottom: 24px;
}

/* 二维码弹窗 */
.qr-popup {
  width: 80%;
  max-width: 320px;
  padding: 24px;
}

.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qr-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}

.qr-canvas {
  width: 200px !important;
  height: 200px !important;
  margin: 0 auto;
}

.qr-desc {
  font-size: 14px;
  color: #666;
  margin-top: 16px;
}

.qr-price {
  font-size: 20px;
  font-weight: bold;
  color: #ee0a24;
}
</style>
